import { useState, useContext } from 'react'

import {
  SanityBlogPostWithoutBody,
  SanityBlogPostOptions,
} from '@data/sanity/queries/types/blog'
import { StringsContext } from '@lib/strings-context'

import BlogPostCard from '@blocks/blog-post-card'
import Button from '@components/buttons/button'

interface BlogPostGridProps {
  posts: SanityBlogPostWithoutBody[]
  options?: SanityBlogPostOptions
  paginationLimit?: number
}

const BlogPostGrid = ({
  posts,
  options,
  paginationLimit = 9,
}: BlogPostGridProps) => {
  const strings = useContext(StringsContext)

  const [pagination, setPagination] = useState([
    ...posts.slice(0, paginationLimit),
  ])

  const [hasMore, setHasMore] = useState(
    posts && posts.length > paginationLimit,
  )

  if (!posts.length) {
    return null
  }

  const hasPagination = paginationLimit > 0
  const postsList = hasPagination ? pagination : posts

  const loadMore = () => {
    const curPage = pagination.length
    const nextPage = posts.slice(curPage, curPage + paginationLimit)
    const newPage = [...pagination, ...nextPage]

    if (hasMore) {
      setPagination(newPage)
      setHasMore(newPage.length < posts.length)
    }
  }

  return (
    <section className="container">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-10 -m-px mb-6">
        {postsList.map((post) => (
          <BlogPostCard
            key={`post-${post.slug}`}
            post={post}
            options={options}
          />
        ))}
      </div>

      {hasPagination && hasMore && (
        <div className="relative py-4 sm:py-8 text-center">
          {hasMore && (
            <Button onClick={loadMore} variant="primary">
              {strings.buttonLoadMore}
            </Button>
          )}
        </div>
      )}
    </section>
  )
}

export default BlogPostGrid
